import { createStore } from 'vuex'
import user from '@/store/user'
import auth from '@/store/auth'
import session from '@/store/session'
import ratings from '@/store/ratings'
import organization from '@/store/organization'

export default createStore({
  state: {
    recentSceondaryLanguages: { maxLength: 10 },
    zoomContext: null,
    zoomMeetingId: null,
  },

  mutations: {
    setRecentlyUsedLanguages(state, val){
      state.recentSceondaryLanguages = val;
    },
    setZoomContext(state, val) {
      state.zoomContext = val;
    },
    setZoomMeetingId(state, val) {
      state.zoomMeetingId = val;
    }
  },

  actions: {
    updateListOfRecentlyUsedSecondaryLanguages({commit, state}, payload){
      let recentLanguages = state.recentSceondaryLanguages;
      const secondaryLangCode = payload.secondaryLangCode;
      const language = {
        secondaryLangCode,
        timestamp: new Date(payload.timestamp).getTime(),
      };
      recentLanguages = { ...recentLanguages, [secondaryLangCode]: language };
      let languages = Object.values(recentLanguages);
      languages = languages.filter(l => typeof l === 'object');
      languages.sort((x, y) => y.timestamp - x.timestamp);
      recentLanguages = { maxLength: 10 };
      languages.forEach((l, i) => {
        if (i < 10)
          recentLanguages = { ...recentLanguages, [l.secondaryLangCode]: l };
      });
      commit("setRecentlyUsedLanguages", recentLanguages);
    },
    updateZoomContext({ commit }, payload) {
      commit("setZoomContext", payload);
    },
    updateZoomMeetingId({ commit }, payload) {
      commit("setZoomMeetingId", payload);
    },
  },
  getters: {
    zoomContext: state => state.zoomContext,
    zoomMeetingId: state => state.zoomMeetingId,
  },

  modules: {
    user,
    auth,
    session,
    ratings,
    organization
  }
})

